import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { WarningSlice } from './types';

const initialState: WarningSlice = {
    id: null,
    overlap : {
        power: false,
        rawaudio: false,
        quiet_periods: false,
    },
    attempt: 0,
    existing: false
}

export const warningSlice = createSlice({
    name: 'warnings',
    initialState,
    reducers: {
        // Reducer to add a brand new warning
        addWarning: (state, action: PayloadAction<WarningSlice>) => {  
            return action.payload
        },
        // Reducer to clear a warning
        resetWarning: (state) => {
            return {
                ...state,
                id: initialState.id,
                overlap: initialState.overlap,
                attempt: initialState.attempt,
                existing: initialState.existing
            }            
        },
        // Reducer to update an existing warning
        editWarning: (state) => {
            return {
                ...state,
                attempt: state.attempt + 1,
                existing: true
            }
        }
    }
});

export const { addWarning, resetWarning, editWarning } = warningSlice.actions;

// Returns overlapping warnings
export const getOverlapWarning = (state: RootState) => {    
    return state.warnings
}

export default warningSlice.reducer;